/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LineWithDot/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LineWithDot({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/LineWithDot",
  isFirst,
  isLast
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="LineWithDot.Vertical"
  data-view-path={viewPath}
 style={{'--h-1-Z12TKcR': isFirst && isLast ? "7px" : isFirst ? "calc(50% + 3.5px)" : isLast ? "calc(50% + 3.5px)" : "auto",'--as-2-Z12TKcR': isFirst && isLast ? "center" : isFirst ? "flex-end" : isLast ? "flex-start" : "initial"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="LineWithDot.Vertical:1"
  data-view-path={viewPath}
 style={{'--blc-3-Z12TKcR': dtColorsNeutral300}}
 className={`views-block ${styles.Vertical1}`}
/>
<div
  data-testid="LineWithDot.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-4-Z12TKcR': dtColorsNeutral300,'--bc-5-Z12TKcR': dtColorsNeutral200,'--t-6-Z12TKcR': isFirst ? "0px" : isLast ? "auto" : "calc(50% - 3.5px)",'--b-7-Z12TKcR': isLast ? "0px" : "auto"}}
 className={`views-block ${styles.Vertical2}`}
/>
</div>
{children}
</React.Fragment>)
}